import { gql } from "@apollo/client";

const GENERATE_SHOWING_TIME_SCHEDULING_URL = gql`
  query generateShowingTimeSchedulingUrl($saleId: ID!) {
    generate_showing_time_scheduling_url(sale_id: $saleId) {
      url
    }
  }
`;

export default GENERATE_SHOWING_TIME_SCHEDULING_URL;
